import { Box } from "@chakra-ui/react";
import VmPricingTable from "./vmTable";
import { CLOUD_VM_SHARED_INTEL } from "./constants";

const SharedIntelPricing = () => {
  return (
    <Box id="older-generation-intel-cpu">
      <VmPricingTable {...CLOUD_VM_SHARED_INTEL} />
    </Box>
  );
};

export default SharedIntelPricing;
